import HeroSection from "../components/AboutSection/HeroSection";
import TeamSection from "../components/AboutSection/TeamSection";

function About() {
  return (
    <>
      <HeroSection />
      <TeamSection />
    </>
  );
}

export default About;
